export const regionsConstants = {
  GET_ALL_SUCCESS: "REGIONS_GET_ALL_SUCCESS",

  GET_SINGLE_SUCCESS: "REGIONS_GET_SINGLE_SUCCESS",

  REQUEST: "REGIONS_REQUEST",
  SAVE_SUCCESS: "REGIONS_SAVE_SUCCESS",
  FAILURE: "REGIONS_FAILURE",
};
